

<template>
  <div class="cm_video_body">
    <div id="cm_video_container" :class="mobileClass('cm_media_box')">
      <div class="cm_common_margin">
        <i class="el-icon-video-play"></i>
        <h3 class="cm_channel_title">保密视频</h3>
      </div>
      <div :class="mobileClass('cm_video_box')">
        <div v-if="videoIsShow" class="cm_video_show_box">
          <video-player
            ref="VideoPlayer"
            class="video-player vjs-custom-skin"
            :options="playerOptions"
          />
          <!-- <video src=""></video> -->
          <ul class="cm_video_catalog">
            <li>
              <h3>目录</h3>
            </li>
            <li v-for="(item,index) in dataList" :key="item.NEWS_ID" @click="changeVideo(item.NEWS_ID,index)" :class="activeNum==index?'cm_active':''">
              <strong>{{index+1}}</strong>
              <span>{{item.TITLE}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="cm_common_margin">
        <div class="cm_video_intro_title">
          <div class="cm_row_line"></div>
          <h3>概述</h3>
        </div>
        <div v-html="content.CONTENT" class="cm_content_detail"></div>
      </div>
      <!-- <div class="cm_common_margin">
        <div class="cm_video_intro_title">
          <div class="cm_row_line"></div>
          <h3>相关推荐</h3>
        </div>
        <div></div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      id: this.$route.params.newsId,
      data: JSON.parse(this.$route.query.parentData),
      content: "",
      videoIsShow: false,
      dataList: [],
      activeNum:"",
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: require("../assets/1.mp4"), // 路径
            type: "video/mp4", // 类型
          },
        ],
        poster: require("../assets/img/bg-logo.png"), //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      windowWidth:document.documentElement.clientWidth
    };
  },
  //监听属性 类似于data概念
  computed: {
    mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
  },
  //监控data中的数据变化
  watch: {
    '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
  },
  //方法集合
  methods: {
    httpPost() {
      let newsId = this.id;
      this.$http({
        url: this.$http.adornUrl("requestMainMobile/pageService/newsDetail"),
        method: "post",
        data: { newsId: newsId },
      }).then(({ data }) => {
        
        if (data.data != "" && data.data != undefined && data.data != null) {
          if (
            data.data.data != "" &&
            data.data.data != undefined &&
            data.data.data != null
          ) {
            this.content = data.data.data;
            this.playerOptions.sources[0].src =
              window.SITE_CONFIG.baseUrl + this.content.FILE0;
            this.playerOptions.poster = this.content.ATTACHMENTPIC0;
            this.videoIsShow = true;
          }
        }
      });
    },
    getList() {
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: "post",
        data: this.data.data,
      }).then(({ data }) => {
        if (data.data != "" && data.data != undefined && data.data != null) {
          
          this.dataList = data.data.pdList;
          for(let i = 0 ;i<this.dataList.length;i++){
            if(this.dataList[i]!=undefined && this.dataList[i].NEWS_ID==this.id){
              this.activeNum = i
              return false
            }
          }
        }
      });
    },

    changeVideo(id,index){
      if(id != this.id){
        this.id = id
        this.activeNum = index
        this.httpPost()
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.httpPost();
    this.getList();
  },
};
</script>
<style >

.cm_content_detail {
  width: 100%;
  margin: 20px 0;
}
.cm_common_margin {
  margin-top: 30px;
  margin-bottom: 20px;
}
.cm_video_show_box {
  display: flex;
  justify-content: space-between;
  padding: 0 102px;
  width: 100%;
}
.cm_video_body {
  display: flex;
  justify-content: center;
  width: 100%;
}
#cm_video_container {
  margin-top: 20px;
  background: #ffffff;
  border: 1px solid #e1e4e7;
  padding: 0 20px;
}
.cm_video_box {
  width: 1160px;
  height: 474px;
  background: #343434;
  display: flex;
  justify-content: center;
}
.cm_video_catalog {
  width: 300px;
}

.cm_video_catalog > li {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #fff;
  padding: 10px 0;
  color: #fff;
}
.el-icon-video-play:before {
  color: #4379d3;
}
.cm_video_catalog > li > strong {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: #575353;
}
.cm_video_catalog > li{
  cursor: pointer;
}
.cm_video_catalog > li > span{
  width: 90%;
}
.cm_video_catalog > li > h3 {
  display: flex;
  justify-content: center;
  color: #fff;
  line-height: 50px;
}
.cm_row_line {
  width: 4px;
  height: 23px;
  background: #4379d3;
}
.cm_video_intro_title {
  display: flex;
  align-items: center;
}
.cm_video_intro_title > h3 {
  margin-left: 20px;
  font-size: 24px;
  font-weight: 600;
  color: #000000;
}
.cm_channel_title {
  display: inline-block;
  font-size: 24px;
  font-weight: 600;
  color: #000000;
}
.el-icon-video-play {
  font-size: 26px;
}
.video-player {
  width: 650px;
  height: 472px;
}
.vjs-custom-skin > .video-js {
  height: 100% !important;
}
.cm_active{
  color:#fbbd08!important;
}

.cm_media_box{
  width: 1200px;
}
.mobile_cm_media_box{
  width: 100%;
}
.mobile_cm_video_box{
  width: 98%;
  background: #343434;
  display: flex;
  justify-content: center;
}
.mobile_cm_video_box>.cm_video_show_box{
  display: flex;
  flex-wrap: wrap;
}
</style>